<form  [formGroup]="submissionForm" >
    <div class="form-container2">
        <h2>SUBMISSION PAGE</h2>
    </div>
  <div class="form-container">
    <h2>{{data.details.creditorName}}</h2>
 
    <!-- Broadcast Name -->
    <label class="form-label">Broadcast Name</label>
        <span class="text-danger">*</span>
    <mat-form-field [floatLabel]="'never'" class="is-invalid">
      <mat-label>Select</mat-label>
      <mat-select id="broadCastName" [disabled]='viewOrEdit' formControlName="broadcastId" class="form-control"  name="broadcastName" [(ngModel)]="formData.broadcastId">
        <mat-option  (click)="onClickToChangeBroadcastName(data.id)"*ngFor="let data of data.broadcastNamePublishDate" [value]="data.id">
          {{ data.broadcastNamePublishDate }}
        </mat-option> 
      </mat-select>
    </mat-form-field>
    <div *ngIf="formData.broadcastId=='' && isFileSubmit" class="invalid-feedback mt-0">
      <div>Broadcast Name is required.</div>
    </div>

 
    <!-- Document Type -->
    <label class="form-label">Document Type</label>
      <span class="text-danger">*</span>
    <mat-form-field [floatLabel]="'never'" class="is-invalid">
      <mat-label>Select</mat-label>
      <mat-select id="documentType" [disabled]='viewOrEdit' formControlName="documentType"  class="form-control"  name="documentType" [(ngModel)]="formData.documentType">
        <mat-option (click)="onClickToChangeDocumentType(data.id)" *ngFor="let data of data.broadcastDocumentTypeLookup" [value]="data.id">
        {{ data.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="formData.documentType=='' && isFileSubmit" class="invalid-feedback mt-0">
      <div>Document Type is required.</div>
    </div>
 
    <!-- Supersede -->
    <label class="form-label">Are you superseding a submitted form?</label>
    <span class="text-danger">*</span>
    <select name="isSuperseding"   formControlName="isSuperseding" [(ngModel)]="formData.isSuperseding" >
      <option value="true">Yes</option>
      <option value="false">No</option>
    </select>

    <div *ngIf="formData.isSuperseding=='true'">
      <label class="form-label">Superseding<span class="text-danger">*</span>:</label>
      <div class="txt-wrap">
          <a  (click)="downloadFile(formData)" class="nav-link txt-wrap pointer"
          [innerHTML]="formData.submittedFileName">{{formData.submittedFileName}} </a>
      </div>
    </div>
    <label class="form-label">Remarks</label>
    <div class="textareaclass mb-3">
      <textarea matInput placeholder="Remarks" maxlength="2000" formControlName="remarks"  class="form-control"[disabled]='viewOrEdit' name="remarks" [(ngModel)]="remarks" (keypress)="addressLineFormat($event)"></textarea>
      <div class="char-counter counter-div">
          <p>
              {{remarks?.length != null ? remarks?.length : 0}}/2000
          </p>
      </div>
    </div> 
    <!-- File Upload -->
    <div class="row">
      <div class="col-md-12">
        <div *ngIf="isSupportingDocumentFileSubmitted" class="d-flex align-items-center error">
          <mat-icon>highlight_off</mat-icon>
          <p class="ml-2">Please submit with supporting documents in order to process this claim.</p>
        </div>
        <app-upload-file
          [folder-path-id]="folderPathId"
          [allow-file-type]="['pdf','xls','xlsx','jpg','jpeg','heic','gif','ppt','pptx','doc','docx']"
          [allow-multi]="false"
          (emitFiles)="getFiles($event)"
          [allow-File-Upload]="viewOrEdit"
          [file-list]="emitFiles"
          [allow-File-Upload]="viewOrEdit"
          [hide-ErrorMessage]="hideError"
          [delete-file]="deletedFiles"
          (emitErrorMessage)="hideMessage()"
          (emitDeletedFile)="getDeletedFiles($event)"
          [isProxy]="true">
        </app-upload-file>
      </div>
    </div>
 
    <!-- Buttons -->
    <div class="row">
      <div class="col-md-6 text-md-right">
        <div class="button-group-secondary">
          <button type="button" class="secondary-button" (click)="onClickToSelectSecondary(data?.secondaryButVal)">
            {{ data?.secondaryButVal }}
          </button>
        </div>
      </div>
      <div class="col-md-6 text-md-left" *ngIf="!viewOrEdit">
        <div class="button-group-secondary">
          <button type="submit" appDebounceClick (debounceClick)="onSubmit()"  class="primary-button">
            {{ data?.primaryButVal }}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>